var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4381 8.10938H3.72484L11.9326 0.984375C12.0639 0.869531 11.9842 0.65625 11.8108 0.65625H9.73656C9.64515 0.65625 9.55843 0.689062 9.49046 0.747656L0.633429 8.43281C0.552309 8.50313 0.487251 8.59006 0.442664 8.68772C0.398076 8.78537 0.375 8.89147 0.375 8.99883C0.375 9.10618 0.398076 9.21228 0.442664 9.30994C0.487251 9.4076 0.552309 9.49453 0.633429 9.56484L9.54202 17.2969C9.57718 17.3273 9.61937 17.3438 9.6639 17.3438H11.8084C11.9819 17.3438 12.0616 17.1281 11.9303 17.0156L3.72484 9.89062H17.4381C17.5412 9.89062 17.6256 9.80625 17.6256 9.70312V8.29688C17.6256 8.19375 17.5412 8.10938 17.4381 8.10938Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.1e97a2b5f18408394de1ce097c1f9eb3.svg";
export { ForwardRef as ReactComponent };